import { useTranslation } from "react-i18next";
import { Tags as TagsFeature } from "@/partner/features/tags";
import { Meta } from "@/shared/components";

export function TagsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("tags.pageTitle")} pageType="Partner" />
      <TagsFeature />
    </>
  );
}
